@let isLoading = $loading | async;
<app-in-play-loader [show]="markets.length === 0 && isLoading || isLoadingStatus()" />
@if (markets.length > 0) {
  @for (each of markets; track each.key) {
    <app-ip-market-item [data]="each" />
  }
}
@if (markets.length === 0 && !isLoading && !isLoadingStatus()) {
  <app-alert
    [config]="{
      title: 'No In-Play Markets',
      subtitle: 'Check back later for updated in-play markets.',
      type: 'info'
    }"
  />
}
